import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Chip } from '@mui/material';

import parentPaths from '../../../services/paths';

const CustomerStatusLabel = ({ customer, sxRoot = {} }) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(`${parentPaths.customers}/${customer.id}`);
  };

  return (
    customer && (
      <Chip
        size="medium"
        label={customer.name}
        sx={{
          backgroundColor: customer.status === 'RUNNING' ? '#99de90' : 'palette.grey.300',
          color: customer.status === 'RUNNING' ? '#fff' : '#9e9e9e',
          ...sxRoot,
        }}
        onDelete={noop}
        onClick={handleClick}
        deleteIcon={(
          <Chip
            size="small"
            label={customer.status === 'RUNNING' ? 'LIVE' : 'TEST'}
            style={{
              backgroundColor: '#fff',
              color: customer.status === 'RUNNING' ? '#99de90' : 'palette.grey.300',
              fontSize: '10px',
            }}
          />
        )}
      />
    )
  );
};

CustomerStatusLabel.propTypes = {
  customer: PropTypes.object,
  sxRoot: PropTypes.object,
};

export default CustomerStatusLabel;
